export {
  FACILITY_TYPE_2_FACILITY_DATA_KEY,
  FACILITY_TYPE_2_NUMBER_FIELDS,
  type FacilityType,
  type FacilityDataKey,
} from '../../../domain/customerInquiry/facilityMapping';

export const BUSINESS_CHARGING_BOOLEAN_KEYS = [
  'isOwnParkingLot',
  'hasOwnCarFleet',
  'isCustomerParkingAllowed',
] as const;
